import axios from 'axios';
import qs from 'query-string';
import { Status, IState } from '@/store/state';

const BASE_URL = '';

interface ISubscribeResponse {
	code: Status;
	message?: string;
}

export interface ISubscribeArgs {
	email: string;
	keywords: string[];
	handlerUrl: string;
}

const SiteVisionHeaders = {
	'X-Requested-With': 'XMLHttpRequest'
};

export const subscribe = (args: ISubscribeArgs): Promise<Status> =>
	process.env.NODE_ENV === 'development' ?
		Promise.resolve(Math.floor((Math.random() * 4) + 1)) :
	axios.post<ISubscribeResponse>(args.handlerUrl, qs.stringify({ ...args, keywords: args.keywords.join(',') }), {
		headers: {
			...SiteVisionHeaders,
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
	.then(response => response.data.code)
	.catch(subscribeError => {
		console.error({
			subscribeError
		})
		return Status.NOT_OK
	})

export const unsubscribe = (url: string): Promise<Status> => axios.get<ISubscribeResponse>(url, { headers: SiteVisionHeaders }).then(response => response.data.code)